const state = {
  token: localStorage.getItem('auth_token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || null,
  isLoggedIn: !!localStorage.getItem('auth_token')
};

const getters = {
  getToken: state => state.token,
  getUserInfo: state => state.userInfo,
  isLoggedIn: state => state.isLoggedIn,
  userName: state => state.userInfo?.username || '用户',
  userAvatar: state => state.userInfo?.avatar || ''
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    localStorage.setItem('auth_token', token);
    state.isLoggedIn = !!token;
  },
  
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  },
  
  CLEAR_AUTH(state) {
    state.token = '';
    state.userInfo = null;
    state.isLoggedIn = false;
    
    // 清除认证相关的 localStorage 字段
    const keys = [
      'token',
      'auth_token',
      'authToken',
      'access_token',
      'Authorization',
      'user_identity',
      'identity',
      'identityId',
      'userId',
      'user_id',
      'userInfo',
      'user_features',
      'user_role',
      'stored_wholesaler_id',
      'stored_customer_id',
      'wholesaler_id',
      'customer_id',
      'driver_id'
    ];
    
    keys.forEach(k => {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    });
  }
};

const actions = {
  /**
   * 登录
   */
  async login({ commit }, credentials) {
    try {
      const response = await this._vm.$api.post('/auth/login', credentials);
      
      // 登录成功，保存 token 和用户信息
      commit('SET_TOKEN', response.token);
      commit('SET_USER_INFO', {
        username: response.username
      });
      
      return response;
    } catch (error) {
      console.error('登录失败:', error);
      throw error;
    }
  },

  /**
   * 退出登录
   */
  async logout({ commit }) {
    // 不调用后端 API，直接清除本地数据
    console.log('退出登录，清除认证信息');
    commit('CLEAR_AUTH');
  },

  /**
   * 获取用户信息
   */
  async getUserInfo({ commit }) {
    try {
      const response = await this._vm.$api.get('/auth/user-info');
      commit('SET_USER_INFO', response);
      return response;
    } catch (error) {
      console.error('获取用户信息失败:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
